import selfInstantiateOnLoad from "../utilities/instantiateUtility";
const dWindow = window;
class FireplaceQuoteModal {
    constructor() {
        this._productData = {};
        this._defaultJson = {};
        this._leadSourceElement = document.getElementById("its-lit-quote-lead-source");
        this._leadTypeElement = document.getElementById("its-lit-quote-lead-type");
        this._errorElement = document.getElementById("its-lit-quote-modal-error-message");
        this._formElement = document.getElementById("its-lit-quote-modal-form");
        this._submitButton = this._formElement.querySelector("[name='Submit']");
        this._initialize();
    }
    _initialize() {
        const jsonElement = document.getElementById("fireplaceQuoteModalSettings");
        const initializedData = JSON.parse(jsonElement.innerText);
        this._productData = initializedData.productData;
        this._defaultJson = initializedData.fireplaceJsonData;
        const quoteButton = document.getElementById("quote-btn");
        if (quoteButton) {
            quoteButton.addEventListener("click", () => this._setupQuoteModal());
        }
        else {
            console.error("#quote-btn does not exist");
        }
    }
    _setupQuoteModal() {
        this._leadTypeElement.textContent = "4";
        this._leadSourceElement.textContent = "348";
        const showOnQuote = document.querySelectorAll(".showOnQuote");
        for (let i = 0; i < showOnQuote.length; i++) {
            showOnQuote[i].style.display = "block";
        }
        const headerTitle = document.getElementById("its-lit-quote-modal-header-title");
        headerTitle.innerHTML = "<strong>Request a Quote</strong>";
        const title = document.getElementById("its-lit-quote-modal-title");
        title.innerHTML = "<strong>Your Info</strong>";
        this._setupQuoteSubmissionMethod();
    }
    _getQuoteFormData() {
        const commentElement = document.getElementById("contactus-comments");
        let comment = commentElement.value.trim() || "";
        let productData = {};
        if (this._leadSourceElement.textContent === "348") {
            productData = this._productData;
        }
        const optOut = document.querySelector("#its-lit-quote-modal-form #optOut"); // Duplicate ID alert!
        if (optOut) {
            comment += `, Do Not Sell Personal Info: ${optOut.checked}`;
        }
        productData.Comments = comment;
        return productData;
    }
    _setQuoteThirdPartyJson() {
        const dealerOnLead = dWindow.DealeronLead;
        dealerOnLead.thirdPartyJsonAdapter.setData(this._defaultJson);
        const requestCall = document.getElementById("requestcall")?.checked ??
            false;
        const newsletter = document.getElementById("newsletter")?.checked ??
            false;
        dealerOnLead.thirdPartyJsonAdapter.setData({
            RequestCall: requestCall,
            Newsletter: newsletter,
        });
    }
    _setupQuoteSubmissionMethod() {
        const dealerOnLead = dWindow.DealeronLead;
        dealerOnLead.addSubmissionMethod("sendFireplaceModalSubmit", {
            leadSource: parseInt(this._leadSourceElement.textContent.trim()),
            leadType: parseInt(this._leadTypeElement.textContent.trim()),
            additionalData: this._getQuoteFormData.bind(this),
            preSubmit: this._presubmit.bind(this),
            successCallback: this._onSuccess.bind(this),
            errorCallback: this._onError.bind(this),
        });
        dealerOnLead.initialize("#its-lit-quote-modal-form", "sendFireplaceModalSubmit");
        const firstInput = this._formElement.querySelector("input:not([type=hidden]), select, textarea");
        firstInput.addEventListener("focus", () => {
            if (dealerOnLead.token.shouldRefresh()) {
                dealerOnLead.begin();
            }
        }, { once: true });
    }
    _presubmit(form) {
        this._errorElement.textContent = "";
        this._submitButton.setAttribute("disabled", "true");
        const showOnQuote = document.querySelectorAll(".showOnQuote");
        for (let i = 0; i < showOnQuote.length; i++) {
            showOnQuote[i].style.display = "none";
        }
        this._setQuoteThirdPartyJson();
    }
    _onSuccess(data) {
        this._errorElement.textContent = "";
        dWindow.DealeronLead.defaultSuccessCallBack(data);
    }
    _onError() {
        this._errorElement.textContent =
            dWindow.DealeronLead.errMsg[dWindow.DealeronLead.currentLocale].submissionError;
        this._submitButton.removeAttribute("disabled");
    }
}
selfInstantiateOnLoad(FireplaceQuoteModal);
